<template>
  <section class="cta">
    <div class="container">
      <AppCard class="text--center">
        <h2 class="cta__heading">
          Get Approved for Your Car Loan
        </h2>
        <p class="cta__text">
          Your online application takes only 3 minutes to complete
          and we only ask for information we actually need.
        </p>
        <AppButtonContinue
          v-data-layer
          data-layer="app_landed_apply"
          class="cta__button"
          @click="$emit('cta-click')"
        >
          Shop Now
        </AppButtonContinue>
      </AppCard>
    </div>
  </section>
</template>

<script>
import AppCard from '@/components/common/cards/AppCard'
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'

export default {
  // Name
  name: 'GetApprovedCTA',

  // Components
  components: {
    AppCard,
    AppButtonContinue
  }
}
</script>

<style scoped lang="scss">
.cta {
  margin: 80px 0;

  @include breakpoint('desktop-up') {
    margin: 140px 0;
  }

  &__heading {
    @include breakpoint('mobile-only') {
      margin: auto;
      max-width: 220px;
    }
  }

  &__button {
    max-width: 225px;
    margin-bottom: 30px;
  }

  &__text {
    max-width: 460px;
    margin: 30px auto;
  }
}
</style>
